import { render, staticRenderFns } from "./EditTemplateModal.vue?vue&type=template&id=0808ef00&scoped=true"
import script from "./EditTemplateModal.vue?vue&type=script&lang=js"
export * from "./EditTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./EditTemplateModal.vue?vue&type=style&index=0&id=0808ef00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0808ef00",
  null
  
)

export default component.exports